export class ListIntegrationsResponse {
    'integrations';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "integrations",
            "baseName": "integrations",
            "type": "Array<IntegrationConfig>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListIntegrationsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
